




























import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class SlideBar extends Vue {
  @Prop({ default: 0 }) current: number
  @Prop({ default: 0 }) total: number
  @Prop({ default: '#7DD420' }) slideColor: string
  @Prop({ default: '#e6e6e6' }) bgColor: string
  @Prop({ default: 'row' }) slideType: string
  @Prop({ default: '' }) maxSize: string
  @Prop({ default: '' }) align: string
  styles = {}
  stylesBg = {}

  @Watch('current')
  @Watch('total')
  watchChange() {
    this.styles = {
      width: (this.current * 100) / this.total + '%',
      'background-color': this.slideColor
    }
  }

  created() {
    this.watchChange()
    this.stylesBg = {
      'background-color': this.bgColor
    }
    if (this.maxSize) {
      this.stylesBg = {
        'background-color': this.bgColor,
        'max-width': this.maxSize
      }
    }
  }
}
